<template>
  <v-app>
    <v-main class="background">
      <v-container
        class="fill-height"
        fluid
      >
        <Alert />
        <flash-messages />
        <slot />
      </v-container>
      <Footer />
    </v-main>
  </v-app>
</template>

<script>
import Footer from '@/Components/Layout/Footer'

export default {
   name: 'BasicLayout',
   components: {
      Footer
   },
}
</script>
